// eslint-disable-next-line import/order -- FIXME
import React, { Fragment } from 'react';

// @material-ui/core components
import FormLabel from '@material-ui/core/FormLabel';
// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import CardBody from 'components/Card/CardBody';
import FormSelectSingle from 'components/FormSelect/FormSelectSingle';
import CardWrapper from 'components/Card/CardWrapper';
import { WAREHOUSE_PRICE_MODES } from 'views/Ingredients/consts';

import WarehousePriceModeTooltip from './WarehousePriceModeTooltip';

const FormIngredientsShopingInformation = ({
  t,
  classes,
  salesOptions,
  state,
  handleWeightChange,
  salesSelectsOptions,
  handleChange,
  currency,
  additionalSalesOptions,
}) => (
  <GridItem xs={12}>
    <CardWrapper title={t('form.field.shoppingInfo')}>
      <CardBody>
        <GridContainer justify="center">
          <GridItem md={10}>
            <GridContainer>
              <GridItem md={3}>
                {salesOptions(currency)?.map((option, index) => (
                  <Fragment key={index}>
                    <FormLabel
                      style={{ marginTop: '8px' }}
                      className={classes.labelHorizontal}
                    >
                      {' '}
                      {option.label}{' '}
                    </FormLabel>
                    <CustomInput
                      disabled={state?.products?.length > 0}
                      id={option?.id}
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        type: option?.type,
                        name: option?.name,
                        onChange: handleWeightChange,
                        value: option?.value,
                      }}
                    />
                  </Fragment>
                ))}
              </GridItem>

              <GridItem md={3}>
                {additionalSalesOptions.map((option, index) => (
                  <Fragment key={index}>
                    <FormLabel
                      style={{ marginTop: '8px' }}
                      className={classes.labelHorizontal}
                    >
                      {option.label}
                    </FormLabel>

                    <CustomInput
                      id={option.id}
                      disabled={option?.disabled}
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        type: option.type,
                        name: option.name,
                        onChange: option.handleChange,
                        value: option.value,
                      }}
                    />
                  </Fragment>
                ))}
              </GridItem>

              <GridItem md={3}>
                {salesSelectsOptions?.map((option, index) => (
                  <option.Component
                    key={index}
                    label={option.label}
                    options={option.options}
                    value={option.value}
                    trackBy={option.trackBy}
                    mapBy={option.mapBy}
                    handleChange={handleChange}
                    name={option.name}
                    id={option.id}
                    labelSm={3}
                    selectSm={4}
                  />
                ))}
              </GridItem>
              <GridItem md={3}>
                {state.products.length > 0 && (
                  <FormSelectSingle
                    label={<WarehousePriceModeTooltip />}
                    options={[
                      {
                        value: WAREHOUSE_PRICE_MODES.WEIGHT,
                        name: t('form.field.warehousePriceMode.weight'),
                      },
                      {
                        value: WAREHOUSE_PRICE_MODES.UNIT,
                        name: t('form.field.warehousePriceMode.unit'),
                      },
                    ]}
                    value={state.warehousePriceMode}
                    trackBy="value"
                    mapBy="name"
                    handleChange={handleChange}
                    name="warehousePriceMode"
                    id="warehousePriceMode"
                    labelSm={3}
                    selectSm={4}
                  />
                )}
                <p>
                  {t('form.field.priceAverage', {
                    replace: { currency },
                  })}
                  : <strong>{state.priceAverage}</strong>
                </p>
                <p>
                  {t('form.field.priceAverageWeighted', {
                    replace: { currency },
                  })}
                  : <strong>{state.priceAverageWeighted}</strong>
                </p>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  </GridItem>
);

export default FormIngredientsShopingInformation;
